module.exports = __webpack_public_path__ + "static/media/coachella-6.28afb290.jpg";